import { FC } from 'react';
import { WrapperProps } from './index.types';
import React, { useEffect, useRef } from 'react';
// import DOMPurify from 'isomorphic-dompurify';

export const StaticWrapper: FC<WrapperProps> = props => {
  const targetDivRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (targetDivRef.current !== null && props?.model?.showLanguageSelector && props?.model?.currentPageLanguage) {
      const element = targetDivRef.current;
      const parentElement = element.querySelector('.language-modal-list') as HTMLElement;
      const currentPageDiv = element.querySelector('.open-language-modal') as HTMLElement;
      const footerParentElement = element.querySelector('.open-language-modal-footer') as HTMLElement;
      const mobileHeader = element.querySelector('.open-language-modal-mobile') as HTMLElement;
      const langList = props?.model?.langNavList;
      const enableClickTracking = props?.model?.enableTracking;
      if (currentPageDiv !== null) {
        const spanTag = document.createElement('span');
        spanTag.className = `icon-website ${enableClickTracking ? 'custom_click_track' : ''}`;
        enableClickTracking &&
          spanTag.setAttribute('data-custom_click_track_value', `${props?.model?.clickTrackValue}`);
        spanTag.textContent = ' ' + props?.model?.currentPageLanguage;
        currentPageDiv.appendChild(spanTag);
      }
      if (footerParentElement !== null) {
        const footerDropdown = document.createElement('div');
        footerDropdown.className = 'brand-footer__dropdown mt-5 mb-4 mb-md-0';
        const aTag = document.createElement('a');
        aTag.className = `mb-md-4 mt-5 d-inline-block  ${enableClickTracking ? 'custom_click_track' : ''}`;
        aTag.setAttribute('href', 'javascript:void(0)');
        enableClickTracking && aTag.setAttribute('data-custom_click_track_value', `${props?.model?.clickTrackValue}`);
        const footerSpan = document.createElement('span');
        footerSpan.className = 'icon-globe pr-2';
        aTag.appendChild(footerSpan);
        const span2 = document.createElement('span');
        span2.innerText = `${props?.model?.currentPageLanguage}`;
        aTag.appendChild(span2);
        footerDropdown.appendChild(aTag);
        footerParentElement.insertBefore(footerDropdown, footerParentElement.firstChild);
      }
      if (mobileHeader !== null) {
        const newChild = document.createElement('span');
        newChild.className = `site-navigation-component__mobile__header__globe icon-website ${
          enableClickTracking ? 'custom_click_track' : ''
        }`;
        enableClickTracking ??
          newChild.setAttribute('data-custom_click_track_value', props?.model?.clickTrackValue || '');
        mobileHeader.insertBefore(newChild, mobileHeader.firstChild);
      }
      langList?.forEach(item => {
        const elem = document.createElement('div');
        elem.className = 'col-6 language-modal-list--item';
        const subElem = document.createElement('div');
        subElem.className = 'language-modal-list--item-text px-2';
        const aTag = document.createElement('a');
        aTag.lang = item.locale || '';
        aTag.className = 't-font-m t-rc-alt-color py-2 px-2 d-block custom_click_track track-completed';
        enableClickTracking && aTag.setAttribute('data-custom_click_track_value', `${item.clickTrackValue}`);
        aTag.href = item.localePagePath || '';
        aTag.innerText = item.languageLabel || '';
        subElem?.appendChild(aTag);
        elem?.appendChild(subElem);
        parentElement?.appendChild(elem);
      });
    } else if (targetDivRef.current !== null && !props?.model?.showLanguageSelector) {
      const element = targetDivRef.current;
      const footerParentElement = element.querySelector('.open-language-modal-footer') as HTMLElement;
      const mobileHeader = element.querySelector('.open-language-modal-mobile') as HTMLElement;
      footerParentElement && footerParentElement.remove();
      mobileHeader && mobileHeader.remove();
    }
  }, []);

  // const sanitizedNode = DOMPurify?.sanitize(props?.model?.['referencePath'] as string, { RETURN_DOM: true });
  // const fragmentString = sanitizedNode?.innerHTML;

  if (props?.model) {
    return (
      // <div data-testid="withModel" ref={targetDivRef} dangerouslySetInnerHTML={{ __html: fragmentString ?? '' }} />
      <div
        data-testid="withModel"
        ref={targetDivRef}
        dangerouslySetInnerHTML={{ __html: props?.model['referencePath'] || '' }}
      />
    );
  } else {
    return <div data-testid="withoutModel"></div>;
  }
};
